import { useContext } from "react";
import useSWR from "swr";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import { ToastContext } from "../context/ToastContext";
import { OrganisationConfigurationModel } from "@attelas/shared";
export const useOrganisationConfigurations = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<OrganisationConfigurationModel>(
    `${environment.apiUrl}/api/organisation/configurations`,
    (url: string) => fetcher(url),
    {
      onError: () => {
        showToast("Failed to get organisation configurations, please try again later", "error");
      },
    }
  );

  return {
    configurations: data,
    isLoading,
    isError: !!error,
  };
};
